import { fromPascalToCamel, fromStatusCodeToGenericError, httpService, WebRequestFactory } from "@pjs/http";
import { ITemporaryAccessDetails } from "../interfaces/ITemporaryAccessDetails";
import { BackendPostGrantEmailTemporaryAccessBody } from "../types/BackendPostGrantEmailTemporaryAccessBody";
import { BackendTemporaryAccessDetailsResponse } from "../types/BackendTemporaryAccessDetailsResponse";
import { apiConfig } from "../../../ApiConfig";

export const grantEmailTemporaryAccess = WebRequestFactory.createPost<ITemporaryAccessDetails, BackendPostGrantEmailTemporaryAccessBody>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: fromPascalToCamel<BackendTemporaryAccessDetailsResponse, ITemporaryAccessDetails>,
    url: () => apiConfig.grantEmailTemporaryAccess()
});
